document.addEventListener("DOMContentLoaded", function () {
  const timers = document.querySelectorAll("[data-countdown-timer]");
  console.log(`Found ${timers.length} countdown timers.`);

  const timerData = Array.from(timers)
    .map((timer, index) => {
      const settingsScript = timer.querySelector("[data-timer-settings]");
      if (!settingsScript) {
        console.log(`Timer ${index + 1}: No settings found.`);
        return null;
      }

      try {
        const settings = JSON.parse(settingsScript.textContent);
        console.log(`Timer ${index + 1} settings:`, settings);

        const {
          availability_date,
          shopTimezone,
          timeZoneSelection,
          hideTimerOnComplete,
          overlay_image_url,
        } = settings;

        if (!availability_date) {
          console.error(`Timer ${index + 1}: Missing availability_date.`);
          return null;
        }

        function parseAvailabilityDate(dateStr) {
          console.log("Parsing availability_date:", dateStr);
          const [datePart, timePart] = dateStr.split("-");
          if (!datePart || !timePart) {
            console.error(
              "Invalid availability_date format. Expected 'YYYY/M/D-HHAM/PM' or 'YYYY/M/D-HH:MMAM/PM'."
            );
            return null;
          }

          const [year, month, day] = datePart.split("/").map(Number);
          if (!year || !month || !day) {
            console.error("Invalid date part in availability_date:", datePart);
            return null;
          }

          let hour = 0,
            minute = 0,
            meridiem = "AM";

          if (timePart.includes(":")) {
            const timeMatch = timePart.match(/^(\d{1,2}):(\d{2})(AM|PM)$/);
            if (!timeMatch) {
              console.error(
                "Invalid time format in availability_date. Expected 'HH:MMAM/PM'."
              );
              return null;
            }
            hour = parseInt(timeMatch[1], 10);
            minute = parseInt(timeMatch[2], 10);
            meridiem = timeMatch[3];
          } else {
            const timeMatch = timePart.match(/^(\d{1,2})(AM|PM)$/);
            if (!timeMatch) {
              console.error(
                "Invalid time format in availability_date. Expected 'HHAM/PM'."
              );
              return null;
            }
            hour = parseInt(timeMatch[1], 10);
            meridiem = timeMatch[2];
          }

          if (meridiem === "PM" && hour !== 12) {
            hour += 12;
          } else if (meridiem === "AM" && hour === 12) {
            hour = 0;
          }

          const parsedDate = new Date(year, month - 1, day, hour, minute, 0);
          if (isNaN(parsedDate.getTime())) {
            console.error(
              "Failed to construct valid date object from:",
              dateStr
            );
            return null;
          }

          return parsedDate.getTime();
        }

        const endDate = parseAvailabilityDate(availability_date);
        if (!endDate) {
          console.error(
            `Timer ${index + 1}: Failed to parse availability_date.`
          );
          return null;
        }

        return { timer, endDate, hideTimerOnComplete, overlay_image_url };
      } catch (error) {
        console.error(`Timer ${index + 1}: Error parsing settings -`, error);
        return null;
      }
    })
    .filter(Boolean);

  const updateAllTimers = setInterval(() => {
    const now = Date.now();

    timerData.forEach(
      ({ timer, endDate, hideTimerOnComplete, overlay_image_url }, index) => {
        const distance = endDate - now;

        if (distance < 0) {
          console.log(`Timer ${index + 1}: Countdown complete.`);
          // Скрываем весь контейнер оверлея (родительский элемент таймера)
          const overlayContainer = timer.parentElement;
          if (overlayContainer) {
            overlayContainer.style.display = "none";
          }
          return;
        }

        const D = Math.floor(distance / (1000 * 60 * 60 * 24));
        const H = Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const M = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const S = Math.floor((distance % (1000 * 60)) / 1000);

        const DElement = timer.querySelector("[data-days]");
        const HElement = timer.querySelector("[data-hours]");
        const MElement = timer.querySelector("[data-minutes]");
        const SElement = timer.querySelector("[data-seconds]");

        if (DElement) DElement.textContent = D;
        if (HElement) HElement.textContent = H;
        if (MElement) MElement.textContent = M;
        if (SElement) SElement.textContent = S;

        const typeElements = timer.querySelectorAll(
          ".countdown-timer__type.fs-accent"
        );

        typeElements.forEach((el) => {
          if (el && el.parentElement) {
            if (el.parentElement.hasAttribute("data-days")) {
              el.textContent = "D";
            } else if (el.parentElement.hasAttribute("data-hours")) {
              el.textContent = "H";
            } else if (el.parentElement.hasAttribute("data-minutes")) {
              el.textContent = "M";
            } else if (el.parentElement.hasAttribute("data-seconds")) {
              el.textContent = "S";
            }

            if (["D", "H", "M", "S"].includes(el.textContent)) {
              Object.defineProperty(el, "textContent", {
                writable: false,
                configurable: false,
              });
            }
          }
        });
      }
    );

    if (timerData.every(({ endDate }) => endDate - now < 0)) {
      console.log("All timers completed. Stopping the interval.");
      clearInterval(updateAllTimers);
    }
  }, 1000);
});
